// extracted by mini-css-extract-plugin
export default {"search-trend-desc-wrapper":"search-trend-desc-wrapper_b5PZj"};